import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AnimatePresence, motion } from "framer-motion";
import AppRoutes from "./routes";
import ScrollToTop from "./components/ScrollToTop";
import FloatingWidgets from "./components/FloatingWidgets";
import Preloader from "./components/Preloader";
import "./assets/css/tailwind-globals.css";
import { ThemeProvider } from "./Utils/useTheme";

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Premium initial website load timer (1.5 seconds)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <ThemeProvider>
      <AnimatePresence mode="wait">
        {loading ? (
          <Preloader key="preloader" />
        ) : (
          <motion.div
            key="app-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="w-full min-h-screen"
          >
            <div className="cyber-grid"></div>
            <ScrollToTop />
            <AppRoutes />
            <FloatingWidgets />
            <ToastContainer position="bottom-right" theme="dark" />
          </motion.div>
        )}
      </AnimatePresence>
    </ThemeProvider>
  );
}
